import { render, staticRenderFns } from "./BotaoEnviarReadequacao.vue?vue&type=template&id=9a602ab2&scoped=true"
import script from "./BotaoEnviarReadequacao.vue?vue&type=script&lang=js"
export * from "./BotaoEnviarReadequacao.vue?vue&type=script&lang=js"
import style0 from "./BotaoEnviarReadequacao.vue?vue&type=style&index=0&id=9a602ab2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a602ab2",
  null
  
)

export default component.exports